import { Variant } from '@monolith/legacy/types/product';

export const findProductVariantById = (variants: Array<Variant>, id: string) => {
  return variants.find((product) => product.uuid === id);
};
